import React from 'react';
import { useTranslation } from 'react-i18next';
import { View, StyleSheet } from 'react-native';
import { i18nNS, useComponentTKey } from '../../i18n';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import Icon from '../Icon';
import RowView from '../RowView';

export default function InvoiceSummaryForMultiPnr({ multiPnrResp }) {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('InvoiceSummary');
  return (
    <>
      {multiPnrResp
        ? multiPnrResp?.map((passenger, index) => {
            return (
              <View key={index}>
                <View style={CommonStyles.py3}>
                  <BaseText style={CommonStyles.h3}>
                    {passenger.FirstName} {passenger.LastName}
                  </BaseText>
                  {passenger.FrequentFlyers.length > 0 && passenger.IsAirExists && (
                    <RowView>
                      <BaseText>{t(tKey('FreqFlyer'))}: </BaseText>
                      {passenger.FrequentFlyers.map((res, index) => {
                        return (
                          <BaseText key={index}>
                            {(index ? ',' : '') + ' ' + res.ProgramNo}
                          </BaseText>
                        );
                      })}
                    </RowView>
                  )}
                  <RowView>
                    {passenger?.KnownTravellerNumber ? (
                      <>
                        <Icon name="check" style={styles.checkIcon} />
                        <BaseText>{t(tKey('KnownTravelerNumber'))}</BaseText>
                      </>
                    ) : (
                      <></>
                    )}
                  </RowView>
                </View>
                <View style={CommonStyles.py3}>
                  <RowView>
                    <BaseText style={styles.informationView}>
                      {t(tKey('RecordLocator'))}: {passenger?.PNR}{' '}
                    </BaseText>
                  </RowView>
                </View>
              </View>
            );
          })
        : null}
    </>
  );
}

const styles = StyleSheet.create({
  informationView: {
    ...CommonProperties.h3,
  },
  checkIcon: {
    color: Color.corporate,
    ...CommonProperties.h3,
    ...CommonProperties.mr3,
  },
  cancelIcon: {
    color: Color.required,
    ...CommonProperties.h3,
    ...CommonProperties.mr3,
  },
});
